export default __webpack_public_path__ + "static/media/typeWriter.92a45a50.jpg";